import React from "react";

/**
 * This is the profile details component
 * @returns {JSX.Element}
 * @constructor
 *
 * @example
 * <div>
 *     <Profile/>
 *     </div>
 */
export default function Profile(){
    return(
        <div>
            Profile!
        </div>
    );
}
